export default {"src":"/_next/static/media/viceroy-snowmass.04732d50.svg","height":75,"width":231,"blurWidth":0,"blurHeight":0};